/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect } from "react";
import { Layout, ConfigProvider } from "antd";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { accountBaseUrl } from "../../helpers/account";
import * as actions from "./actions";
import LocationCard from "components/LocationCard";
import { getLocations } from "./reducers";
import { clearBooking } from "../Booking/actions";
import ContentContainer from "../../components/ContentContainer";
import { useDispatch } from "react-redux";
import { trackEvent } from "utils/analytics";

const { Content } = Layout;

const Locations = ({ fetchLocationsRequest, locations, clearBooking }) => {
	const dispatch = useDispatch();

	useEffect(() => {
		fetchLocationsRequest();
		clearBooking();
	}, [fetchLocationsRequest, clearBooking]);

	const setCurrentLocation = useCallback(
		(location) => {
			dispatch(actions.fetchCurrentLocationSuccess(location));
			trackEvent("location_selected", {
				location_id: location.id,
				location_name: location.name,
			});
		},
		[dispatch],
	);

	return (
		<ContentContainer
			pageTitle="Select Location"
			step="1"
			stepPercentage={20}
			showNext={false}
		>
			<Content className="">
				{locations?.map((location) => (
					<ConfigProvider themeColor={location?.themeColor} key={location?.id}>
						<div key={location.id}>
							<Link
								to={`${accountBaseUrl}/locations/${location.id}/patient-type`}
								onClick={() => setCurrentLocation(location)}
							>
								<LocationCard
									themeColor={location?.themeColor}
									{...location}
									border={true}
								/>
							</Link>
						</div>
					</ConfigProvider>
				))}
			</Content>
		</ContentContainer>
	);
};

const mapStateToProps = (state) => ({
	locations: getLocations(state.locations),
});

export default connect(mapStateToProps, { ...actions, clearBooking })(
	Locations,
);
